"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PenguinPummelAbilityHandler = exports.PenguinPummelActorAbilityFactory = exports.PenguinPummelAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const Settings_1 = require("../../Settings");
class PenguinPummelAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.PenguinPummel;
        this.__typeName = "PenguinPummel";
    }
}
exports.PenguinPummelAbilityArgs = PenguinPummelAbilityArgs;
let PenguinPummelActorAbilityFactory = class PenguinPummelActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("PenguinPummel", "AllEnemies", 4);
    }
};
PenguinPummelActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("PenguinPummel")
], PenguinPummelActorAbilityFactory);
exports.PenguinPummelActorAbilityFactory = PenguinPummelActorAbilityFactory;
let PenguinPummelAbilityHandler = class PenguinPummelAbilityHandler {
    constructor() {
        this.randomBuffs = Array.of(...[
            enums_1.AttributeType.Power,
            enums_1.AttributeType.Focus,
            enums_1.AttributeType.Will,
            enums_1.AttributeType.Vitality,
        ].map(attr => (level, focus) => new core_2.MaxAttributeIncreaseEffectArgs(attr, level * Settings_1.BASE_LEVEL_ADR + Math.round(focus * .1))), ...[
            enums_1.AttributeType.AllDamageResistance,
        ].map(attr => (level, focus) => new core_2.MaxAttributeIncreaseEffectArgs(attr, level + Math.round(focus * .1))), ...[
            enums_1.AttributeType.AllDamagePercentIncrease,
        ].map(attr => (level, focus) => new core_2.MaxAttributeIncreaseEffectArgs(attr, level + Math.round(focus * .1))), ...[
            enums_1.AttributeType.ChaosDamageImmunity,
            enums_1.AttributeType.DeathDamageImmunity,
            enums_1.AttributeType.FireDamageImmunity,
            enums_1.AttributeType.FrostDamageImmunity,
            enums_1.AttributeType.HolyDamageImmunity,
            enums_1.AttributeType.SonicDamageImmunity,
            enums_1.AttributeType.NatureDamageImmunity,
            enums_1.AttributeType.PhysicalDamageImmunity
        ].map(attr => (level, focus) => new core_2.MaxAttributeIncreaseEffectArgs(attr, Math.round(level * .2))), ...[
            enums_1.AttributeType.ChaosDamagePercentIncrease,
            enums_1.AttributeType.DeathDamagePercentIncrease,
            enums_1.AttributeType.FireDamagePercentIncrease,
            enums_1.AttributeType.FrostDamagePercentIncrease,
            enums_1.AttributeType.HolyDamagePercentIncrease,
            enums_1.AttributeType.SonicDamagePercentIncrease,
            enums_1.AttributeType.NatureDamagePercentIncrease,
            enums_1.AttributeType.PhysicalDamagePercentIncrease,
        ].map(attr => (level, focus) => new core_2.MaxAttributeIncreaseEffectArgs(attr, Math.round(level * .2))), () => new core_2.HasteEffectArgs(1), () => new core_2.HasteEffectArgs(2));
        this.randomDebuffs = Array.of(...[
            enums_1.AttributeType.AllDamageResistance,
        ].map(attr => (level, focus) => new core_2.MaxAttributeDecreaseEffectArgs(attr, level + Math.round(focus * .1))), ...[
            enums_1.AttributeType.ChaosDamageImmunity,
            enums_1.AttributeType.DeathDamageImmunity,
            enums_1.AttributeType.FireDamageImmunity,
            enums_1.AttributeType.FrostDamageImmunity,
            enums_1.AttributeType.HolyDamageImmunity,
            enums_1.AttributeType.SonicDamageImmunity,
            enums_1.AttributeType.NatureDamageImmunity,
            enums_1.AttributeType.PhysicalDamageImmunity,
        ].map(attr => (level, focus) => new core_2.MaxAttributeDecreaseEffectArgs(attr, Math.round(level * .2))), () => new core_2.StunEffectArgs(), () => new core_2.SlowEffectArgs(1), () => new core_2.SlowEffectArgs(2));
    }
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const allies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        const level = container.getLevel(ability.invokerId);
        const focus = container.getAttributeScore(ability.invokerId, enums_1.AttributeType.Focus);
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: Array((0, Random_1.random)(5, 10)).fill(0)
                .map(() => ({
                creatorId: ability.invokerId,
                targetId: (0, Random_1.randomElement)(enemies),
                jitter: (0, Random_1.random)(25, 225),
                type: "Penguin",
                path: "arc",
                end: "feet",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Physical", 50)
                ]
            })),
            onHit: (sequence, _attack, _damages, { targetId }) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "CannonBallExplosion"));
                const buff = (0, Random_1.randomElement)(this.randomBuffs)(level, focus);
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: (0, Random_1.randomElement)(allies),
                    duration: Duration_1.Duration.Turns(2),
                    effect: buff
                });
                const debuff = (0, Random_1.randomElement)(this.randomDebuffs)(level, focus);
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(2),
                    effect: debuff
                });
            }
        });
    }
};
PenguinPummelAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.PenguinPummel)
], PenguinPummelAbilityHandler);
exports.PenguinPummelAbilityHandler = PenguinPummelAbilityHandler;
